import { render, staticRenderFns } from "./Search-Address.vue?vue&type=template&id=15dde4e0&scoped=true"
import script from "./Search-Address.vue?vue&type=script&lang=js"
export * from "./Search-Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dde4e0",
  null
  
)

export default component.exports